import {
  Modal,
  ModalBody,
  ModalContent,
  ModalHeader,
  ModalOverlay,
  useDisclosure,
  Text,
  Tooltip,
  IconButton,
} from '@chakra-ui/react';
import Add from 'components/Icons/Add';
import AssignCouponForm from 'pages/CouponPools/Listing/components/AssignCouponModal/AssignCouponForm';

function AssignCouponModal({ couponPoolId }: { couponPoolId: string }) {
  const { onOpen, isOpen, onClose } = useDisclosure();

  return (
    <>
      <Modal isOpen={isOpen} onClose={onClose} size="lg">
        <ModalOverlay />
        <ModalContent>
          <ModalBody>
            <ModalHeader>
              <Text variant="h4" fontWeight={600}>
                Przypisz kupon
              </Text>
            </ModalHeader>
            <AssignCouponForm couponPoolId={couponPoolId} onClose={onClose} />
          </ModalBody>
        </ModalContent>
      </Modal>
      <Tooltip label="Dodaj kupon" openDelay={500}>
        <IconButton
          aria-label="edit"
          icon={<Add />}
          width="32px"
          height="32px"
          variant="ghost"
          onClick={onOpen}
        />
      </Tooltip>
    </>
  );
}

export default AssignCouponModal;
